import { render } from "./BlogPreventiveSportsSplints.vue?vue&type=template&id=0e146b94"
import script from "./BlogPreventiveSportsSplints.vue?vue&type=script&lang=js"
export * from "./BlogPreventiveSportsSplints.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__